import React, { useState, useCallback } from 'react';
import { FormLabel, TextField } from '@cko/primitives';
import { IconActionPassword } from '@cko/icons';
import ShowPasswordButton from '../ShowPasswordButton';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const PasswordField = ({ password, handlePasswordChange, title = '', error, ...rest }) => {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = useCallback(() => {
        setShowPassword(!showPassword);
    }, [showPassword]);
    const onChange = useCallback((e) => {
        const newPassword = e.target.value;
        handlePasswordChange(newPassword);
    }, [handlePasswordChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLabel, { htmlFor: "password-field", isRequired: true }, title),
        React.createElement(TextField, { error: Boolean(error), id: "password-field", prefix: React.createElement(IconActionPassword, { "data-testid": "icon-action-password" }), suffix: React.createElement(ShowPasswordButton, { showPassword: showPassword, onToggle: togglePasswordVisibility, "data-testid": "show-password-button" }), onChange: onChange, type: showPassword ? 'text' : 'password', value: password, ...rest })));
};
